/**
 * ecom-ppp.js: price-per-unit rules for the PDP and the family table (design fixes T7/T11, Wes 2026-10-01).
 * Spock D1-D3 (2026-10-01) + Mira's spec. Theme-only: no product, price or metafield writes.
 *
 * Pieces: the variant metafield custom.pieces_per_pack when present (not created yet; waits on Brian),
 * otherwise the "(N pcs)" in the Package Quantity label. custom.box_quantity is never used.
 *
 * Decision order (first match wins):
 *   1. future metafield flag custom.ppp_rule = "hide" (variant or product)             -> hide
 *   2. exception lists in assets/ecom-ppp-data.js (generated from Spock's CSVs):
 *        q3 within-product outlier product                                              -> hide
 *        weight-denominated / kit or set / tool or chemical variant                      -> hide
 *   3. threaded rod (data list, or future product flag custom.ppp_rule = "per_ft"):
 *        stick length known -> $/ft = price / (N x stick ft); otherwise                  -> hide
 *   4. data flag require_metafield (after the backfill) and no metafield                 -> hide
 *   5. no count in the label ("Each") or N <= 1                                          -> hide
 *   6. otherwise                                                                         -> $/pc
 * If the data asset fails to load, everything hides (fail closed: never show a wrong number).
 * Rounding: 3 decimals under $1, 2 decimals at $1 or more.
 */
(function (w) {
  'use strict';
  var sets = null;
  function dec(s) {
    var out = new Set(), prev = 0;
    if (!s) return out;
    s.split(',').forEach(function (p) { prev += parseInt(p, 36); out.add(String(prev)); });
    return out;
  }
  function load() {
    if (sets) return sets;
    var D = w.EcomPPPData;
    if (!D) return null;
    var rod = new Map();
    Object.keys(D.rod || {}).forEach(function (ft) { dec(D.rod[ft]).forEach(function (id) { rod.set(id, parseFloat(ft)); }); });
    sets = { v: D.v, requireMf: !!D.require_metafield, w: dec(D.hv_w), k: dec(D.hv_k), t: dec(D.hv_t), q3: dec(D.hp_q3), rod: rod, rodNolen: dec(D.rod_nolen) };
    return sets;
  }
  function parsePieces(label) {
    var m = String(label || '').match(/\(([\d,]+)\s*pcs?\)/i);
    if (!m) return 0;
    var n = parseInt(m[1].replace(/,/g, ''), 10);
    return n > 0 ? n : 0;
  }
  function fmt(dollars) {
    if (!(dollars >= 0) || !isFinite(dollars)) return '';
    var mills = Math.round(dollars * 1000);
    if (mills < 1000) return '$0.' + String(mills).padStart(3, '0');
    return '$' + (Math.round(dollars * 100) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function hide(reason) { return { mode: 'hide', unit: '', text: '', perUnit: null, reason: reason }; }
  /**
   * o: { productId, variantId, priceCents, label, piecesMf (custom.pieces_per_pack or null),
   *      ruleV / ruleP (custom.ppp_rule on variant / product, future), stickFtMf (future product metafield) }
   * returns { mode: 'pc'|'ft'|'hide', unit, text ('$0.233'), perUnit (dollars, for sorting/savings), pieces, reason }
   */
  function decide(o) {
    var S = load();
    if (!S) return hide('rules_unavailable');
    var pid = String(o.productId || ''), vid = String(o.variantId || '');
    var ruleV = String(o.ruleV || '').toLowerCase(), ruleP = String(o.ruleP || '').toLowerCase();
    var mf = parseInt(o.piecesMf, 10);
    var pieces = mf > 0 ? mf : parsePieces(o.label);
    var r;
    if (ruleV === 'hide' || ruleP === 'hide') r = hide('metafield_flag');
    else if (S.q3.has(pid)) r = hide('q3_outlier_product');
    else if (S.w.has(vid)) r = hide('weight_denominated');
    else if (S.k.has(vid)) r = hide('kit_or_set');
    else if (S.t.has(vid)) r = hide('tool_or_container');
    else if (ruleP === 'per_ft' || S.rod.has(pid) || S.rodNolen.has(pid)) {
      var ft = parseFloat(o.stickFtMf) || S.rod.get(pid) || 0;
      if (ft > 0 && pieces > 0 && o.priceCents >= 0) {
        var per = o.priceCents / 100 / (pieces * ft);
        r = { mode: 'ft', unit: 'ft', text: fmt(per), perUnit: per, reason: 'threaded_rod' };
      } else r = hide('rod_length_unknown');
    }
    else if (S.requireMf && !(mf > 0)) r = hide('no_pieces_metafield');
    else if (!pieces) r = hide('no_count_in_label');
    else if (pieces <= 1) r = hide('single_piece');
    else {
      var pp = o.priceCents / 100 / pieces;
      r = { mode: 'pc', unit: 'pc', text: fmt(pp), perUnit: pp, reason: 'ok' };
    }
    r.pieces = pieces;
    return r;
  }
  function stats() {
    var S = load();
    return S ? { v: S.v, weight: S.w.size, kit: S.k.size, tool: S.t.size, q3: S.q3.size, rod: S.rod.size, rodNolen: S.rodNolen.size } : null;
  }
  w.EcomPPP = { decide: decide, parsePieces: parsePieces, format: fmt, stats: stats };
})(window);
